@if (submitInfo(); as submitInfo) {
  @if (submitInfo.textConfirmProposal) {
    <div class="ion-padding-bottom screen-text-with-newlines">{{ submitInfo.textConfirmProposal }}</div>
  }
  <pa-generic-data-table [list]="dataList()" />

  <ion-textarea
    class="md-block ion-padding-top"
    label="{{ 'label.explanation' | translate }} ({{ 'label.mandatory' | translate }})"
    labelPlacement="floating"
    placeholder="{{ 'submitProposal.placeholderStudentExplanation' | translate }}"
    [(ngModel)]="studentExplanation"
    (ionInput)="onStudentExplanationChange()"
    [maxlength]="explanationMaxLength"
    [counter]="true"
    fill="solid"
    auto-grow="true"
  >
  </ion-textarea>

  <!-- file upload start-->
  @if (isUploadPossible()) {
    <div class="ion-margin-vertical">
      <div class="ion-margin-top">
        <b>{{ 'submitProposal.uploadDocument' | translate }}</b>
        @if (isUploadRequired()) {
          ({{ 'label.mandatory' | translate }})
        }
      </div>
      @if (submitInfo.textConfirmUpload) {
        <div class="screen-text-with-newlines">{{ submitInfo.textConfirmUpload }}</div>
      }
      <ion-button fill="solid" color="secondary" size="small" (click)="fileSelect.click()" class="ion-margin-top">
        {{ 'submitProposal.selectFile' | translate }}
        <input
          #fileSelect
          type="file"
          id="fileSelect"
          name="fileSelect"
          [disabled]="maxUploadCountReached()"
          (change)="onFileChange($event)"
          multiple
        />
      </ion-button>
      @if (isUploadRequired()) {
        <div>{{ 'submitProposal.uploadRequired' | translate }}</div>
      }
    </div>
  }

  @if (selectedFiles.length) {
    <div>
      @for (file of selectedFiles; track $index) {
        <div class="file-row">
          <ion-icon name="attach" color="success" />
          <a href="#" (click)="openFile(file)" class="file-name">{{ file.name }}</a>
          <a #downloadLink class="hidden-anchor"></a>
          <ion-icon name="close-outline" (click)="removeFile($index)" />
        </div>
      }
    </div>
  }

  @if (messages().length) {
    <hr class="warning-divider" />
    <div>
      @for (message of messages(); track message.message) {
        <div class="warning">
          <pa-status-message [melding]="message" />
        </div>
      }
    </div>
  }
}
